import React from 'react';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';

const LabeledBox = ({
  label,
  children,
  onClick,
  className,
  outerClassName,
  sx,
  noBackground,
  size,
  outerSx = {},
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const shrink = Boolean(children);

  return (
    <Box
      onClick={onClick}
      className={
        `relative transition-colors w-full outer-box ` + (outerClassName || '')
      }
      sx={{
        minHeight: size === 'small' ? '40px' : '56px',
        backgroundColor: noBackground ? 'unset' : colors.bgInput,
        ':hover': {
          cursor: onClick ? 'pointer' : 'auto',
          border: label ? 'unset' : '1px solid ' + colors.info + '80!important',
        },
        'fieldset:hover': {
          border: '1px solid ' + colors.info + '80!important',
        },
        border: label ? 'unset' : `1px solid ${colors.selected}`,
        borderRadius: '10px',
        position: 'relative',
        ...outerSx,
      }}
    >
      {label && (
        <fieldset
          style={{
            border: `1px solid ${colors.selected}`,
            color: 'transparent',
            borderRadius: '10px',
            position: 'absolute',
            top: `-8px`,
            left: '0',
            width: '100%',
            height: `calc(100% + 8px)`,
            transition: 'border-color 0.2s ease',
          }}
        >
          <legend
            style={{
              fontSize: '0.75rem',
              padding: shrink ? '0 5px 0px 12px' : '0px',
              transition: 'max-width 0.2s ease',
              maxWidth: shrink ? '200px' : '0px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              visibility: shrink ? 'visible' : 'hidden',
            }}
          >
            {label}
          </legend>
        </fieldset>
      )}
      <Box
        sx={{
          transform: shrink && 'matrix(0.75, 0, 0, 0.75, 14, -9)',
          transformOrigin: 'top left',
          fontSize: shrink ? 'auto' : '13.7px',
          position: shrink ? 'absolute' : 'relative',
          minHeight: shrink ? 'auto' : size === 'small' ? '40px' : '53px',
          display: 'flex',
          alignItems: 'center',
          padding: shrink ? 'unset' : '0px 12px',
          textAlign: 'start',
          fontWeight: 400,
        }}
      >
        {label}
      </Box>
      {children && (
        <Box
          sx={{
            padding: size === 'small' ? '8.5px 14px!important' : '15px',
            outline: 'none',
            width: '100%',
            height: '100%',
            ...sx,
          }}
          className={className}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

export default LabeledBox;
